import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiModule } from '../../ui/ui.module';

import { SipPhoneCallComponent } from './sip-phone-call.component';
import { SipPhoneCallDirective } from './sip-phone-call.directive';

@NgModule({
	imports: [
		CommonModule,
		UiModule,
	],
	declarations: [
		SipPhoneCallComponent,
		SipPhoneCallDirective,
	],
	exports: [
		SipPhoneCallComponent,
		SipPhoneCallDirective,
	],
})
export class SipPhoneCallModule { }
